import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface readerLinkMtdSalesDataInterface {
  MTD: any | number;
}

interface readerLinkYtdSalesDataInterface {
  YTD: any | number;
}

interface readerLinkLtdSalesDataInterface {
  LTD: any | number;
}

interface readerLinkDataObj {
  mtdData: readerLinkMtdSalesDataInterface;
  ytdData: readerLinkYtdSalesDataInterface;
  ltdData: readerLinkLtdSalesDataInterface;
  dataAsOf?: string | null;
}

interface TitleListReaderLinkState {
  data: readerLinkDataObj;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}

const initialState: TitleListReaderLinkState = {
  data: {
    mtdData: {
      MTD: 0,
    },
    ytdData: {
      YTD: 0,
    },
    ltdData: {
      LTD: 0,
    },
    dataAsOf: null,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListReaderLinkRecord = createAsyncThunk(
  "FetchTitleListReaderLinkRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.ReaderLinkTITLESALESDATA, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListReaderLinkSlice = createSlice({
  name: "TitleListReaderLinkData",
  initialState,
  reducers: {
    emptyReaderLinkPosSales: (state) => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListReaderLinkRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListReaderLinkRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(FetchTitleListReaderLinkRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const { emptyReaderLinkPosSales } = TitleListReaderLinkSlice.actions;
export default TitleListReaderLinkSlice.reducer;
